import React from "react";
import { withStyles } from "@material-ui/core/styles";
import QuestionAnswerOutlinedIcon from "@material-ui/icons/QuestionAnswerOutlined";
import ToolTip from "../../../../../common/StyledToolTip";
import styles from "./styles";

const Message = ({ classes, onClick }) => (
  <div className={classes.scHeaderCloseButton} onClick={onClick}>
    <ToolTip title="Canned msgs">
      <QuestionAnswerOutlinedIcon
        className={classes.scHeaderMsgIcon}
      ></QuestionAnswerOutlinedIcon>
    </ToolTip>
  </div>
);

export default withStyles(styles)(Message);
